<div
  class="dropdown"
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()"
>
  @if (title) {
    <div class="header">
      <h3 class="title">{{ title }}</h3>
    </div>
  }
  <div class="body">
    <ng-content></ng-content>
  </div>
  <div class="footer">
    <ng-content select="[dropdownFooter]"></ng-content>
  </div>
</div>
